import React from "react";
import T from "prop-types";
import { Map } from "immutable";
import withFormFields from "MODULES/shared/decorators/withFormFields";
import CompanyAddress from "MODULES/Orders/shared/ShippingFields/CompanyAddress";
import * as F from "MODULES/shared/components/Forms/FormTypes";

function ShipToCompany(props) {
  const {
    company,
    setFOB,
    ship_to_type: shippingType,
    ship_to_company_id: companyId,
    ship_to_company_address_id: addressId,
    ship_to_address_phone: addressPh,
    onChangeAddress
  } = props;

  return (
    <CompanyAddress
      shippingType={shippingType}
      companyId={companyId}
      setFOB={setFOB}
      addressId={addressId}
      addressPh={addressPh}
      selectedCompany={!company || company.isEmpty() ? null : company.toJS()}
      onChangeAddress={onChangeAddress}
    />
  );
}

ShipToCompany.propTypes = {
  company: T.instanceOf(Map),
  setFOB: T.func,
  onChangeAddress: T.func,
  ship_to_type: F.formField(F.stringInput).isRequired,
  ship_to_company_id: F.formField(F.malleable).isRequired,
  ship_to_company_address_id: F.formField(F.malleable).isRequired,
  ship_to_address_phone: F.formField(F.malleable)
};

export default withFormFields(ShipToCompany, [
  "ship_to_type",
  "ship_to_company_id",
  "ship_to_company_address_id",
  "ship_to_address_phone"
]);



// WEBPACK FOOTER //
// ./app/modules/shared/components/ShippingSection/ShipToCompany.jsx